module.exports = __webpack_public_path__ + "img/3.ea93f646.jpg";